import React from 'react';
import { Card, Collapse, Tag } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccFabrication } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const FabricationUnitWorkstationView: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccFabrication(params);
  const workstations = (data as { workstations?: Array<{ workstation: string; units: Record<string, unknown>[] }> })?.workstations ?? [];

  return (
    <Card id="fabrication" title="Fabrication unit workstation view" style={{ marginTop: 16 }} loading={isLoading}>
      <Collapse
        items={workstations.map((ws) => ({
          key: ws.workstation,
          label: ws.workstation,
          children: (
            <div>
              {ws.units.map((u, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                  <Tag>Unit {String(u.unit_number ?? '—')}</Tag>
                  <Tag color="blue">{String(u.operation)}</Tag>
                  <Tag>{String(u.stage_status)}</Tag>
                  {u.inspection_status ? <Tag color="orange">Insp: {String(u.inspection_status)}</Tag> : null}
                </div>
              ))}
            </div>
          ),
        }))}
      />
    </Card>
  );
};

export default FabricationUnitWorkstationView;
